import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Constants} from '../../common/constants';
import {FieldConfigName} from '../../../models';
import {ControlDialogOptionsHelper} from '../control-dialog-options-helper';

@Component({
  selector: 'app-date-input-dialog',
  templateUrl: './date-input-dialog.component.html'
})
export class DateInputDialogComponent extends ControlDialogOptionsHelper implements OnInit {
  constants: any = Constants;
  editDateInputForm: UntypedFormGroup;
  options: UntypedFormGroup;
  status: boolean;
  control: FieldConfigName;
  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<DateInputDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    if (data) {
      this.control = data.control || this.control;
    }
  }

  ngOnInit(): void {
    this.validateFormBuilder();
    this.setProperty(this.control);
  }

  validateFormBuilder(): void {
    this.editDateInputForm = this.formBuilder.group({
      tooltip: ['', []],
      label: ['', []],
      placeholder: ['', []],
      isRequired: [false],
      options: this.formBuilder.group({
        publicDays: [true],
        holidays: [true],
        closedDays: [true],
        saturday: [true],
        sunday: [true],
        monday: [true],
        tuesday: [true],
        wednesday: [true],
        thursday: [true],
        friday: [true],
      }),
    });
  }

  setProperty(control: any): void {
    this.status = control.options.isRequired;
    this.options = this.editDateInputForm.get('options') as UntypedFormGroup;

    this.editDateInputForm.setValue({
      tooltip: control.options.tooltip || '',
      label: control.options.label,
      placeholder: control.options.placeholder || '',
      isRequired: control.options.isRequired,
      options: this.options.value,
    });

    const options = control.options.options || {};
    this.options.setValue(
      {
        publicDays: options.publicDays ?? true,
        holidays: options.holidays ?? true,
        closedDays: options.closedDays ?? true,

        saturday: options.saturday ?? true,
        sunday: options.sunday ?? true,

        monday: options.monday ?? true,
        tuesday: options.tuesday ?? true,
        wednesday: options.wednesday ?? true,
        thursday: options.thursday ?? true,
        friday: options.friday ?? true,
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.editDateInputForm.invalid) {
      return;
    }
    this.dialogRef.close(this.editDateInputForm.value);
  }
}
